var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tooltip"},[_c('span',{staticClass:"tooltip__trigger",on:{"mouseenter":function($event){_vm.showTooltip = true},"mouseleave":function($event){_vm.showTooltip = false}}},[_vm._t("trigger")],2),(_vm.showTooltip && _vm.$slots.content[0].text)?_c('span',{staticClass:"tooltip__content"},[_vm._t("content")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }